/**
 * The Role Types a contact can be
 */
export enum RoleType {
  SENIOR_INFLUENCER = 1,
  DECISION_MAKER = 2,
  TEAM_MEMBER = 3,
  OTHER = 4,
}

/**
 * Roles a system user can be added to
 */
export enum Role {
  ADMIN = 'admin',
  BILLING = 'billing',
  MANAGER = 'manager',
  USER = 'user',
}
